module.exports = __webpack_public_path__ + "img/nationalMobile.38cea8f9.png";